import apiClient from "./api-client";
import { getSessionId } from "./engagement";

const UUID_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

/** Pull a conceptId out of the current path (/concepts/<uuid>/...), if any. */
export function conceptIdFromPath(pathname: string): string | null {
  const m = pathname.match(new RegExp(`/concepts/(${UUID_RE.source})`, "i"));
  return m ? m[1] : null;
}

export interface FreeformFeedbackPayload {
  comment: string;
  context?: Record<string, unknown>;
}

/**
 * Send freeform beta feedback. Context (route, concept, build SHA, session)
 * is assembled here so call sites only supply the comment — testers won't
 * reliably describe where they were, so we capture it for them.
 */
export async function sendFreeformFeedback({
  comment,
  context = {},
}: FreeformFeedbackPayload): Promise<void> {
  const route = window.location.pathname;
  await apiClient.post("api/feedback", {
    json: {
      comment,
      concept_id: conceptIdFromPath(route),
      context: { route, ...context },
      app_version: import.meta.env.VITE_GIT_SHA ?? "unknown",
      session_id: getSessionId(),
    },
  });
}
